<template>
  <div class="drop--item--card__container">
    <div class="drop--item--card__date">
      <span :class="['drop--item--card__date--subtitle']">{{order.ref}}</span>
    </div>
    <div class="drop--item--card__organization width--longer">
      <span class="drop--item--card__organization--title">
       {{ computedCardTitle }}
      </span>
      <span class="drop--item--card__organization--subtitle ">
        <span>{{ computedCardAddress }}</span>
        <!-- <span class="dotted--before--text">{{splitAddress.countryCode}}</span> -->
      </span>
    </div>
    <!-- <div class="drop--item--card__info">
      <DropCardInfo :icon="'fas fa-box'" :text="computeWeight" />
      <DropCardInfo :icon="'fas fa-arrows-alt'" :text="computeVolume" />
    </div> -->
    <div class="drop--item--card__labels width--longer">
      <!-- <div class="drop--item--card--label__item width--longer">
        <span>Item Name</span>
      </div> -->
      <div v-show="order.labels != null && order.labels.length > 0" class="drop--item--card--label__item width--longer">
        <span v-for="label in order.labels" :key="label">{{ label }}</span>
      </div>
      <div v-show="order.status != null && order.status != ''" class="drop--item--card--label__item width--longer">
        <span>{{$t('transport_request.'+order.status)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrdersOverviewCard',
  props: {
    order: { type: Object, default: () => {} }
  },
  mounted () {
  },
  computed: {
    splitAddress: function () {
      let addressArray = this.order.delivery.address.split(',')
      let address = { city: addressArray[0], countryCode: addressArray[1] }
      return address
    },
    computedCardTitle () {
      switch (this.order.type) {
        case 'Transport':
          return this.order.destination.orgName
          break
        default:
          return this.order.buyer.name
          break;
      }
    },
    computedCardAddress () {
      switch (this.order.type) {
        case 'Transport':
          let loc_ref = ''
          let loc_name = ''
          if (this.order.destination.ref !== '' && this.order.destination.ref !== undefined) {
            loc_ref = this.order.destination.ref.substring(0, 8);
            if (loc_ref.length  < this.order.destination.ref.length && loc_ref.length > 0) {
              loc_ref += '...'
            }
            loc_ref = (loc_ref !== '' ? '•' + loc_ref : '')
          }
          if (this.order.destination.name !== '' && this.order.destination.name !== undefined) {
            loc_name = this.order.destination.name.substring(0, 8);
            if (loc_name.length  < this.order.destination.name.length && loc_ref.length > 0) {
              loc_name += '...'
            }
            loc_name = (loc_name !== '' ? '•' + loc_name : '')
          }
          return this.order.destination.address + loc_name + loc_ref
          break
        default:
          return this.order.buyer.address
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
